import 'core-js/modules/web.dom.iterable';
import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontfamily/fontfamilyui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import {
    createDropdown,
    addListToDropdown
} from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { normalizeOptions } from './utils';
import { FONT_FAMILY } from '../utils';
import fontFamilyIcon from '../../theme/icons/font-family.svg';
/**
 * The font family UI plugin. It introduces the `'fontFamily'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var FontFamilyUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(FontFamilyUI, _Plugin);
    var _super = _createSuper(FontFamilyUI);
    function FontFamilyUI() {
        _classCallCheck(this, FontFamilyUI);
        return _super.apply(this, arguments);
    }
    _createClass(FontFamilyUI, [
        {
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = editor.t;
                var options = this._getLocalizedOptions();
                var command = editor.commands.get(FONT_FAMILY);
                // Register UI component.
                editor.ui.componentFactory.add(FONT_FAMILY, function (locale) {
                    var dropdownView = createDropdown(locale);
                    addListToDropdown(dropdownView, _prepareListOptions(options, command));
                    dropdownView.buttonView.set({
                        label: t('Font Family'),
                        icon: fontFamilyIcon,
                        tooltip: true
                    });
                    dropdownView.extendTemplate({ attributes: { class: 'ck-font-family-dropdown' } });
                    dropdownView.bind('isEnabled').to(command);
                    // Execute command when an item from the dropdown is selected.
                    _this.listenTo(dropdownView, 'execute', function (evt) {
                        editor.execute(evt.source.commandName, { value: evt.source.commandParam });
                        editor.editing.view.focus();
                    });
                    return dropdownView;
                });
            }    /**
     * Returns options as defined in `config.fontFamily.options` but processed to account for
     * editor localization, i.e. to display {@link module:font/fontfamily~FontFamilyOption}
     * in the correct language.
     *
     * Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
     * when the user configuration is defined because the editor does not exist yet.
     *
     * @private
     * @returns {Array.<module:font/fontfamily~FontFamilyOption>}.
     */
        },
        {
            key: '_getLocalizedOptions',
            value: function _getLocalizedOptions() {
                var editor = this.editor;
                var t = editor.t;
                var options = normalizeOptions(editor.config.get(FONT_FAMILY).options);
                return options.map(function (option) {
                    // The only title to localize is "Default" others are font names.
                    if (option.title === 'Default') {
                        option.title = t('Default');
                    }
                    return option;
                });
            }
        }
    ]);
    return FontFamilyUI;
}(Plugin);
// Prepares FontFamily dropdown items.
// @private
// @param {Array.<module:font/fontsize~FontSizeOption>} options
// @param {module:font/fontsize/fontsizecommand~FontSizeCommand} command
export {
    FontFamilyUI as default
};
function _prepareListOptions(options, command) {
    var itemDefinitions = new Collection();
    // Create dropdown items.
    var _iterator = _createForOfIteratorHelper(options), _step;
    try {
        var _loop = function _loop() {
            var option = _step.value;
            var def = {
                type: 'button',
                model: new Model({
                    commandName: FONT_FAMILY,
                    commandParam: option.model,
                    label: option.title,
                    withText: true
                })
            };
            def.model.bind('isOn').to(command, 'value', function (value) {
                return value === option.model;
            });
            // Try to set a dropdown list item style.
            if (option.view && option.view.styles) {
                def.model.set('labelStyle', 'font-family: '.concat(option.view.styles['font-family']));
            }
            itemDefinitions.add(def);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally {
        _iterator.f();
    }
    return itemDefinitions;
}